import { Activity } from '../types';
import { get, post, put, del } from './api';

// Get all activities
export const getActivities = async (): Promise<Activity[]> => {
  return get('/api/activities');
};

// Get activities by family ID
export const getActivitiesByFamily = async (familyId: string): Promise<Activity[]> => {
  return get(`/api/activities/family/${familyId}`);
};

// Get activities by user ID
export const getActivitiesByUser = async (userId: string): Promise<Activity[]> => {
  return get(`/api/activities/user/${userId}`);
};

// Get activity by ID
export const getActivityById = async (activityId: string): Promise<Activity> => {
  return get(`/api/activities/${activityId}`);
};

// Create new activity
export const createActivity = async (activity: Partial<Activity>): Promise<Activity> => {
  return post('/api/activities', activity);
};

// Update activity
export const updateActivity = async (activityId: string, activityData: Partial<Activity>): Promise<Activity> => {
  return put(`/api/activities/${activityId}`, activityData);
};

// Update activity status
export const updateActivityStatus = async (activityId: string, status: string): Promise<Activity> => {
  return put(`/api/activities/${activityId}/status`, { status });
};

// Delete activity
export const deleteActivity = async (activityId: string): Promise<void> => {
  return del(`/api/activities/${activityId}`);
};
